import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BanknoteIcon, UsersIcon, MessageCircleOffIcon } from 'lucide-react';
const problems = [{
  icon: BanknoteIcon,
  title: 'Discusiones constantes por dinero o tiempo',
  description: 'Cada conversación sobre plata termina en pelea. El estrés financiero se convirtió en el tercer integrante de la relación.'
}, {
  icon: UsersIcon,
  title: 'Sensación de ser socios y no amantes',
  description: 'Se sienten más como compañeros de cuarto que como pareja. La logística reemplazó a la intimidad.'
}, {
  icon: MessageCircleOffIcon,
  title: 'Falta de comunicación profunda',
  description: 'Hablan de cuentas, horarios y problemas, pero hace meses que no tienen una conversación real.'
}];
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#0D002B]" data-id="element-172">
      <div className="max-w-6xl mx-auto px-6" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-20" data-id="element-174">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-serif" data-id="element-175">
            Cuando el mundo exterior se mete en la cama
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-176">
          {problems.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-10 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col items-center text-center" data-id="element-177">
                <div className="w-16 h-16 bg-[#7C3AED]/20 rounded-full flex items-center justify-center mb-8" data-id="element-178">
                  <Icon className="w-8 h-8 text-[#7C3AED]" strokeWidth={2} data-id="element-179" />
                </div>
                <h3 className="text-xl font-bold text-[#1E0A3C] mb-4 font-serif leading-snug" data-id="element-180">
                  {item.title}
                </h3>
                <p className="text-[#3B1F6E] leading-relaxed font-sans font-medium" data-id="element-181">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}